// frontend/src/services/OccupancyService.js
// import axios from 'axios';
import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';

const API_URL = '/occupancy';

// Helper to ensure numeric fields are numbers and dates are in YYYY-MM-DD
const sanitizeOccupancyData = (occupancyData) => {
  const data = { ...occupancyData };
  const authStore = useAuthStore();
  data.company_id = data.company_id || authStore.currentUser?.company_id;

  if (data.tenant_id) data.tenant_id = Number(data.tenant_id);
  if (data.unit_id) data.unit_id = Number(data.unit_id);
  if (data.rate) data.rate = Number(data.rate);
  // if (data.occupancy_type) data.occupancy_type = Number(data.occupancy_type);
  if (data.notice_period_days) data.notice_period_days = Number(data.notice_period_days);

  // Ensure dates are in YYYY-MM-DD string format or null
  // Vuetify date pickers usually provide this format or a Date object.
  // If Date object, convert. If already string, ensure format.
  const formatDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) return date.toISOString().split('T')[0];
    return date; // Assuming it's already YYYY-MM-DD
  };
  data.start_date = formatDate(data.start_date);
  data.end_date = formatDate(data.end_date);
  return data;
};


export default {
  async getOccupancies() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    let url = API_URL;
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    const response = (await apiClient.get(url));
    // Dates from backend should be YYYY-MM-DD strings, which is fine for display
    // and for re-sending if not changed. Date pickers will handle them.
    return response.data;
  },

  async getOccupancy(id) {
    const response = (await apiClient.get(`${API_URL}/${id}`));
    return response.data;
  },

  async createOccupancy(occupancyData) {
    const response = (await apiClient.post(API_URL, sanitizeOccupancyData(occupancyData)));
    return response.data;
  },

  async updateOccupancy(id, occupancyData) {
    const response = (await apiClient.put(`${API_URL}/${id}`, sanitizeOccupancyData(occupancyData)));
    return response.data;
  },

  async deleteOccupancy(id) {
    return (await apiClient.delete(`${API_URL}/${id}`));
  }
};